<template>
    <div class="release-list">
        <v-card>
            <v-card-title style="background-color: rgb(33, 57, 141); color: white;">
                {{$t('release.release')}}
                <v-spacer></v-spacer>
                <v-btn dark icon :to="{name: 'release-new'}"><v-icon>add</v-icon></v-btn>
            </v-card-title>
            <v-data-table :headers="headers" :items="loadAll" class="elevation-1" :search="search" :pagination.sync="pagination">
                <template slot="headerCell" slot-scope="props">
                    {{$t(props.header.text)}}
                </template>
                <template v-slot:items="props">
                    <td>{{ props.item.attributes.title }}</td>
                    <td>{{ props.item.attributes.revision }}</td>
                    <td>{{ props.item.attributes.verified_date }}</td>
                    <td>
                        <span v-if="props.item.attributes.locked == true" style="color: red;">{{$t('message.locked')}}</span>
                        <span v-if="props.item.attributes.verified_date == null && props.item.attributes.locked == null" style="color: orange;">{{$t('message.open')}}</span>
                        <span v-if="props.item.attributes.verified_date != null && props.item.attributes.locked == null" style="color: green;">{{$t('message.approved')}}</span>
                    </td>
                    <td class="text-sm-right">
                        <v-btn icon :to="{ name: 'release-detail', params: { id: props.item.id }}"><v-icon color="primary">edit</v-icon></v-btn>
                        <v-btn icon @click="deletePost(props.item);"><v-icon color="primary">delete</v-icon></v-btn>
                    </td>
                </template>
                <v-alert v-slot:no-results :value="true" color="error" icon="warning">
                    Your search for "{{ search }}" found no results.
                </v-alert>
            </v-data-table>
        </v-card>

    </div>
</template>

<script  >
    import {Component, Vue} from 'vue-property-decorator';
    import {mapActions, mapGetters} from 'vuex';

    export default {
        mounted() {
            const httpClient = this.axios.create({
                baseURL: process.env.VUE_APP_API,
                headers: {'Content-Type': 'application/vnd.api+json'},
            });

            httpClient.get('releases/openByMe').then((response) => {
                this.loadAll = response.data.data;
            })
        },
        methods: {
            ...mapActions({
                deletePost: 'releases/delete',
            }),
        },
        computed: {
            ...mapGetters({
                loading: "releases/isLoading",
                error: "releases/isError",
            }),
        },
        data() {
            return {
                loadAll: [],
                search: "",
                headers: [
                    {text: 'release.title', align: 'left', value: 'attributes.title'},
                    {text: 'release.revision', value: 'attributes.revision'},
                    {text: 'release.verfication_date', value: 'attributes.veryfied_date'},
                    {text: 'release.status', value: 'attributes.veryfied_date'},
                    {text: '', align: 'right', value: 'actions'},
                ],
                pagination: {
                    rowsPerPage: 10,
                },
            };
        },
    };
</script>
